import * as React from 'react';
import { useState } from 'react';
import { Box, Button, Loader } from 'wix-style-react';
import axios from 'axios';
import { saveAs } from 'file-saver';

export const xsrfCookieKey = 'XSRF-TOKEN';
export const xsrfHeaderKey = 'x-xsrf-token';

export const getXsrfCookie = () => {
  const x = document.cookie.indexOf(xsrfCookieKey);
  const y = document.cookie.indexOf('=', x);
  const z = document.cookie.includes(';', y)
    ? document.cookie.indexOf(';', y)
    : undefined;
  return document.cookie.substring(y + 1, z);
};

const downloadPdf = (pdfUrl, onDownloadPDF, token) => {
  return axios.post(pdfUrl, {token,"x-xsrf-token": getXsrfCookie()}, {
    headers: {
      'content-type': 'application/json',
      'Accept': 'text/html,application/xhtml+xml',
    },
    responseType: 'blob',
  })
}

export const PdfDownloader = ({ token, text, pdfUrl, onDownloadPDF, onDownloadFail, experiments }) => {
  const [showLoader, setShowLoader] = useState(false);

  if (experiments?.experiments?.['specs.crm.InvoiceAxiosPdf'] === 'true') {
    return (
      <Button theme="whiteblueprimary" dataHook="download-pdf-button" onClick={() => {
      setShowLoader(true);
      downloadPdf(pdfUrl, onDownloadPDF, token)
        .then((response => {
          saveAs(response.data, 'Invoice.pdf');
          onDownloadPDF();
        }))
        .catch(onDownloadFail)
        .then(() => setShowLoader(false));
    }}>
      <Box align="center" width="110px">
        {showLoader ? <Loader size="tiny" /> : text}
      </Box>
    </Button>)
  }
  else {
    return (
      <form method="POST" action={pdfUrl} onSubmit={onDownloadPDF}>
        <Button
          theme="whiteblueprimary"
          dataHook="download-pdf-button"
          type="submit"
        >
          {text}
        </Button>
        <input type="hidden" name="token" value={token} />
        <input type="hidden" name={xsrfHeaderKey} value={getXsrfCookie()} />
      </form>
    )
  }
}